    <div class="mb-3">{{ 'Request.View.SigningDialog.SelectYourCertificateProvider' | translate }}</div>

    <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <div ngbDropdown class="dropdown z-index-select" [(ngModel)]="changedSignatureProvider" ngDefaultControl>
            <button class="btn btn-sm dropdown-toggle form-control text-truncate default" type="button" id="dropdownMenu" ngbDropdownToggle>
                {{ newSignatureProviderName ? newSignatureProviderName : signatureProviderName }}
                <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
            </button>
            
            <div ngbDropdownMenu aria-labelledby="dropdownMenu">
                <ng-container *ngFor="let provider of signatureProviders; let i = index;">
                    <button ngbDropdownItem class="btn-sm" [value]="provider" (click)="setSignMethod(provider)">
                    <ng-container *ngIf="provider.signatureProviderType === 'AdssSignatureProvider'">
                        <ng-container *ngIf="provider.name.indexOf('Pkisigning_') === 0">
                            {{ 'Request.View.SigningDialog.ESeal' | translate }}
                        </ng-container>
                        <ng-container *ngIf="provider.name.indexOf('Pkisigning_') !== 0">
                            {{ 'Request.View.SigningDialog.ESeal' | translate }} ({{ (provider.description.split(",")[0]).split("CN=")[1] ? (provider.description.split(",")[0]).split("CN=")[1] : "" }})
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="provider.signatureProviderType === 'TokenCertificateSignatureProvider'">
                        {{ 'Request.View.SigningDialog.Token' | translate }}
                    </ng-container>
                    <ng-container *ngIf="provider.signatureProviderType === 'HardTokenAgentSignatureProvider'">
                        {{ 'Request.View.SigningDialog.TokenAgent' | translate }}
                    </ng-container>
                    <ng-container *ngIf="provider.signatureProviderType !== 'AdssSignatureProvider' && provider.signatureProviderType !== 'TokenCertificateSignatureProvider' && provider.signatureProviderType !== 'HardTokenAgentSignatureProvider'">
                        {{provider.name}}
                            <ng-container *ngIf="provider.parameters.length > 0 && provider.parameters[0].indexOf('test') > -1">
                                {{ 'Request.View.SigningDialog.Test' | translate }}
                            </ng-container>
                    </ng-container>
                    </button>
                </ng-container>
            </div>
        </div>
    </div>